import * as React from "react";
import CustomField from "../../../../../model/customField/CustomField";
import CreateCustomFieldFormView from "./CreateCustomFieldFormView";

interface IComponentProps {
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Create custom field.
	 * @param {CustomField} customField
	 * @param {void} onActionFinish
	 */
	createCustomField: (customField: CustomField, onActionFinish: () => void) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

export default class CreateCustomFieldForm extends React.PureComponent<IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {isSubmitting: false};
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitFinish = this.onSubmitFinish.bind(this);
	}

	render() {
		return (
			<CreateCustomFieldFormView onSubmit={this.onSubmit}
									   onCancel={this.props.onCancel}
									   isSubmitting={this.state.isSubmitting}/>
		);
	}

	onSubmit(data: CustomField) {
		this.setState({isSubmitting: true}, () => {
			this.props.createCustomField(data, this.onSubmitFinish);
		});
	}

	onSubmitFinish() {
		this.setState({isSubmitting: false})
	}
}